import { render, staticRenderFns } from "./popup-set-spec.vue?vue&type=template&id=ba37640a&scoped=true"
import script from "./popup-set-spec.vue?vue&type=script&lang=js"
export * from "./popup-set-spec.vue?vue&type=script&lang=js"
import style0 from "./popup-set-spec.vue?vue&type=style&index=0&id=ba37640a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba37640a",
  null
  
)

export default component.exports